// extracted by mini-css-extract-plugin
export default {"container":"ZxORtuUS611nVUXN1Dd5","heading":"xIoNEMeK2N7m93KZfFsA"};